// @ts-nocheck
import React, { createRef } from "react";
import NormalSpin from "../../../../base/basicComponents/spin";
import SubmitNewProcedureComplete from "./submitNewProcedureComplete";
import ProcedureFileProcess from "..";
import ApproveNewProcedurePending from "./approveNewProcedurePending";
import ApproveNewProcedureComplete from "./approveNewProcedureComplete";
import ReviseNewProcedureComplete from "./reviseNewProcedureComplete";
import ReviseNewProcedurePending from "./reviseNewProcedurePending";
import styles from "../style/index.module.scss";
import {
  handleSortFileByStatus,
  processDefaultTableSortFile,
  actions,
  flowCategoryId,
} from "../../../publicDictionaryValues";
import AppSetting from "config/AppSetting";

const user = AppSetting.localStorageValue.user.get();
const procedureReplaceFileRef = createRef();
const procedureRef = createRef();
const procedureServerPathRef = createRef();
const procedureSavedInRef = createRef();
const approvePageRef = createRef();
export default class CreateNewProcedureProcess extends ProcedureFileProcess {
  /* sort procedure files follow status in revise page */
  handleSortFile = (result: any) => {
    const tiggerTimes = result.sequence;
    let isRevise = false;
    if (
      result.workflowProcessStepInfo !== null &&
      result.workflowProcessStepInfo.annotations.length !== 0
    ) {
      isRevise =
        result.workflowProcessStepInfo.annotations.find((item: any) => item.name === "IsRevise")
          .value === "1";
    }
    if (tiggerTimes > 1) {
      return handleSortFileByStatus(
        result.procedureFolder?.procedureFiles,
        this._formateDate,
        isRevise
      );
    }
    return processDefaultTableSortFile(result.procedureFolder?.procedureFiles, this._formateDate);
  };

  handleCreateNewProcedurePageType = () => {
    const { procedureStepStatus } = this.state.pageState;

    // @ts-ignore
    this.isApprovePendingPage = this.isApprovePage && procedureStepStatus === "Pending";
    // @ts-ignore
    this.isRevisePendingPage = this.isRevisePage && procedureStepStatus === "Pending";
    // @ts-ignore
    this.isSubmitCompletePage =
      this.isRevisePage && procedureStepStatus === "Complete" && this.triggerTimes === 1;
    // @ts-ignore
    this.isReviseCompletePage =
      this.isRevisePage && procedureStepStatus === "Complete" && this.triggerTimes > 1;
    // @ts-ignore
    this.isApproveCompletePage = this.isApprovePage && procedureStepStatus === "Complete";
  };

  handleCreateNewProcedureTableData = () => {
    return JSON.parse(JSON.stringify(this.state.fileTableData));
  };

  handleCreateNewProcedureNewRejectReason = (rejectReason: any) => {
    return rejectReason;
  };

  handleCreateNewProcedurePageProps = () => {
    const {
      receiveDate,
      requestByName,
      procedureStatus,
      rejectStatus,
      currentRole,
      flowCategoryID,
    } = this.state.pageState;

    return {
      flowCategoryID,
      receiveDate,
      requestByName,
      procedureStatus,
      rejectStatus,
      currentRole,
      procedureReplaceFileRef,
    };
  };

  handleCreateNewProcedureSectionProps = () => {
    const { taskInfoData, procedureInfoData } = this.state;

    return {
      taskInfoData,
      procedureInfoData,
      ppoList: this.state.ppoList,
    };
  };

  handleCreateNewProcedureSavedInProps = () => {
    const {
      savedInReturnReasonInputValue,
      savedInReturnReasonValue,
      savedInReasonStatus,
      procedureSaveInCategoryStatusID,
      savedInRadioValue,
    } = this.state.savedInSectionState;

    return {
      savedInReturnReasonInputValue,
      savedInReturnReasonValue,
      savedInReasonStatus,
      procedureSaveInCategoryStatusID,
      savedInRadioValue,
      // @ts-ignore
      initSavedInStatus: this.initSavedInSectionState.procedureSaveInCategoryStatusID,
      // @ts-ignore
      savedInReturnReasonLog: this.savedInReturnReasonLog,
    };
  };

  handleCreateNewProcedureServerPathProps = () => {
    const {
      clientServerPathStatusName,
      serverPathReturnReasonValue,
      serverPathReasonStatus,
      serverPathReturnReasonInputValue,
      clientServerPathStatusID,
      serverPathValue,
    } = this.state.serverPathSectionState;

    return {
      clientServerPathStatusName,
      serverPathReturnReasonValue,
      serverPathReasonStatus,
      serverPathReturnReasonInputValue,
      // @ts-ignore
      serverPathReturnReasonLog: this.serverPathReturnReasonLog,
      clientServerPathStatusID,
      serverPathValue,
    };
  };

  handleCreateNewProcedureParams = () => {
    return {
      // @ts-ignore
      ProcedureTaskId: this.taskID,
      // @ts-ignore
      ProcedureID: this.procedureID,
      // @ts-ignore
      ProcedureStepID: this.procedureStepID,
      // @ts-ignore
      ProcedureFileStepID: this.procedureFileStepID,
      // @ts-ignore
      WorkflowProcessInstanceId: this.workflowProcessInstanceId,
      // @ts-ignore
      FlowCategoryID: this.flowCategoryID,
    };
  };

  handleCreateNewProcedureReviseNewProcedurePending = (procedureTableData: any) => {
    const { shareTaskData, supportingTableData } = this.state;

    return (
      // @ts-ignore
      <ReviseNewProcedurePending
        procedureServerPathRef={procedureServerPathRef}
        procedureRef={procedureRef}
        procedureSavedInRef={procedureSavedInRef}
        pageProps={{
          ...this.handleCreateNewProcedurePageProps(),
          isDisableAll: false,
        }}
        sectionProps={this.handleCreateNewProcedureSectionProps()}
        savedInProps={this.handleCreateNewProcedureSavedInProps()}
        serverPathProps={this.handleCreateNewProcedureServerPathProps()}
        initSavedInSectionState={(this as any).initSavedInSectionState}
        initServerPathSectionState={(this as any).initServerPathSectionState}
        initProcedureFileTableState={(this as any).initProcedureFileTableState}
        initProcedureTableData={[...(this as any).initProcedureTableData]}
        data={procedureTableData}
        shareTaskData={shareTaskData}
        supportingTableData={supportingTableData}
        params={this.handleCreateNewProcedureParams()}
        updateProcedureFileNum={this.updateProcedureFileNum}
        returnFileDataValue={(this as any).returnFileDataValue}
        handleReturnSubmitData={this.handleReturnSubmitData}
        primitiveSavedInSectionState={(this as any).primitiveSavedInSectionState}
        primitiveServerPathSectionState={(this as any).primitiveServerPathSectionState}
        closePage={this.closePage}
        _showLoading={this._showLoading}
        _hideLoading={this._hideLoading}
        setShareTaskData={this.setShareTaskData}
        setProcedureInfoData={this.setProcedureInfoData}
        setSupportingFileData={this.setSupportingFileData}
      />
    );
  };

  handleCreateNewProcedureReviseCompletePage = (procedureTableData: any) => {
    const { shareTaskData, supportingTableData } = this.state;
    // @ts-ignore
    const isCopyPage = this.flowCategoryID && this.flowCategoryID === flowCategoryId.copyProcedure;

    return (
      // @ts-ignore
      <ReviseNewProcedureComplete
        pageProps={{
          ...this.handleCreateNewProcedurePageProps(),
          isDisableAll: true,
        }}
        sectionProps={this.handleCreateNewProcedureSectionProps()}
        savedInProps={this.handleCreateNewProcedureSavedInProps()}
        serverPathProps={this.handleCreateNewProcedureServerPathProps()}
        data={procedureTableData}
        params={this.handleCreateNewProcedureParams()}
        procedureRef={procedureRef}
        procedureSavedInRef={procedureSavedInRef}
        procedureServerPathRef={procedureServerPathRef}
        _showLoading={this._showLoading}
        _hideLoading={this._hideLoading}
        updateProcedureFileNum={this.updateProcedureFileNum}
        initSavedInSectionState={(this as any).initSavedInSectionState}
        initServerPathSectionState={(this as any).initServerPathSectionState}
        initProcedureFileTableState={(this as any).initProcedureFileTableState}
        initProcedureTableData={[...(this as any).initProcedureTableData]}
        closePage={this.closePage}
        shareTaskData={shareTaskData}
        supportingTableData={supportingTableData}
        returnFileDataValue={(this as any).returnFileDataValue}
        handleReturnSubmitData={this.handleReturnSubmitData}
        primitiveSavedInSectionState={(this as any).primitiveSavedInSectionState}
        primitiveServerPathSectionState={(this as any).primitiveServerPathSectionState}
        isCopyPage={isCopyPage}
        setShareTaskData={this.setShareTaskData}
        setProcedureInfoData={this.setProcedureInfoData}
        setSupportingFileData={this.setSupportingFileData}
      />
    );
  };

  handleCreateNewProcedureApprovePendingPage = (procedureTableData: any, newRejectReason: any) => {
    const { shareTaskData, supportingTableData } = this.state;
    const { excludedReviewersList = [] } = this.state.pageState;

    return (
      // @ts-ignore
      <ApproveNewProcedurePending
        ref={approvePageRef}
        approvePageRef={approvePageRef}
        sectionProps={this.handleCreateNewProcedureSectionProps()}
        savedInProps={this.handleCreateNewProcedureSavedInProps()}
        serverPathProps={this.handleCreateNewProcedureServerPathProps()}
        params={this.handleCreateNewProcedureParams()}
        procedureRef={procedureRef}
        procedureSavedInRef={procedureSavedInRef}
        procedureServerPathRef={procedureServerPathRef}
        _showLoading={this._showLoading}
        _hideLoading={this._hideLoading}
        pageProps={{
          ...this.handleCreateNewProcedurePageProps(),
          newRejectReason,
          // @ts-ignore
          actionID: this.actionID,
          isDisableAll: false,
          isDisableAllActionButtons: excludedReviewersList.some(
            (id: any) => id === user.identityUserInfo.internalUserID
          ),
        }}
        updateProcedureFileNum={this.updateProcedureFileNum}
        returnFileDataValue={(this as any).returnFileDataValue}
        handleReturnSubmitData={this.handleReturnSubmitData}
        closePage={this.closePage}
        supportingTableData={supportingTableData}
        initSavedInSectionState={(this as any).initSavedInSectionState}
        initServerPathSectionState={(this as any).initServerPathSectionState}
        initProcedureTableData={[...(this as any).initProcedureTableData]}
        initProcedureFileTableState={(this as any).initProcedureFileTableState}
        data={procedureTableData}
        shareTaskData={shareTaskData}
        setShareTaskData={this.setShareTaskData}
        setProcedureInfoData={this.setProcedureInfoData}
        setSupportingFileData={this.setSupportingFileData}
      />
    );
  };

  handleCreateNewProcedureApproveCompletePage = (procedureTableData: any, newRejectReason: any) => {
    const { shareTaskData, supportingTableData } = this.state;
    // @ts-ignore
    const isCopyPage = this.flowCategoryID && this.flowCategoryID === flowCategoryId.copyProcedure;
    // @ts-ignore
    const isRejectCompletePage = this.actionID === actions.reject;

    return (
      // @ts-ignore
      <ApproveNewProcedureComplete
        ref={approvePageRef}
        approvePageRef={approvePageRef}
        pageProps={{
          ...this.handleCreateNewProcedurePageProps(),
          newRejectReason,
          // @ts-ignore
          actionID: this.actionID,
          isDisableAll: true,
        }}
        data={procedureTableData}
        shareTaskData={shareTaskData}
        params={this.handleCreateNewProcedureParams()}
        procedureRef={procedureRef}
        procedureSavedInRef={procedureSavedInRef}
        procedureServerPathRef={procedureServerPathRef}
        _showLoading={this._showLoading}
        _hideLoading={this._hideLoading}
        updateProcedureFileNum={this.updateProcedureFileNum}
        returnFileDataValue={(this as any).returnFileDataValue}
        handleReturnSubmitData={this.handleReturnSubmitData}
        closePage={this.closePage}
        supportingTableData={supportingTableData}
        sectionProps={this.handleCreateNewProcedureSectionProps()}
        savedInProps={this.handleCreateNewProcedureSavedInProps()}
        serverPathProps={this.handleCreateNewProcedureServerPathProps()}
        initSavedInSectionState={(this as any).initSavedInSectionState}
        initServerPathSectionState={(this as any).initServerPathSectionState}
        initProcedureTableData={[...(this as any).initProcedureTableData]}
        initProcedureFileTableState={(this as any).initProcedureFileTableState}
        isCopyPage={isCopyPage}
        setShareTaskData={this.setShareTaskData}
        setProcedureInfoData={this.setProcedureInfoData}
        setSupportingFileData={this.setSupportingFileData}
        isRejectCompletePage={isRejectCompletePage}
      />
    );
  };

  handleCreateNewProcedureSubmitCompletePage = (procedureTableData: any) => {
    const { shareTaskData, supportingTableData } = this.state;

    const { savedInRadioValue } = this.state.savedInSectionState;
    const { serverPathValue } = this.state.serverPathSectionState;

    // @ts-ignore
    const isCopyPage = this.flowCategoryID && this.flowCategoryID === flowCategoryId.copyProcedure;

    return (
      <SubmitNewProcedureComplete
        serverPathValue={serverPathValue}
        savedInRadioValue={savedInRadioValue}
        fileTableData={procedureTableData}
        params={this.handleCreateNewProcedureParams()}
        pageProps={this.handleCreateNewProcedurePageProps()}
        sectionProps={this.handleCreateNewProcedureSectionProps()}
        shareTaskData={shareTaskData}
        supportingTableData={supportingTableData}
        isCopyPage={isCopyPage}
        setShareTaskData={this.setShareTaskData}
        setProcedureInfoData={this.setProcedureInfoData}
        setSupportingFileData={this.setSupportingFileData}
      />
    );
  };

  render() {
    const { loading, procedureFileNum, uploadProcedureFileNum, rejectReason } =
      this.state.pageState;

    const procedureTableData = this.handleCreateNewProcedureTableData();

    this.handleCreateNewProcedurePageType();

    let newRejectReason = this.handleCreateNewProcedureNewRejectReason(rejectReason);

    return (
      <NormalSpin
        spinning={loading}
        size="large"
        indicator={
          procedureFileNum > 0 ? (
            <p className={styles.loadingText}>
              Uploading {uploadProcedureFileNum}/{procedureFileNum} file
            </p>
          ) : undefined
        }
      >
        <>
          {/* @ts-ignore */}
          {this.isRevisePendingPage &&
            this.handleCreateNewProcedureReviseNewProcedurePending(procedureTableData)}
          {/* @ts-ignore */}
          {this.isReviseCompletePage &&
            this.handleCreateNewProcedureReviseCompletePage(procedureTableData)}
          {/* @ts-ignore */}
          {this.isApprovePendingPage &&
            this.handleCreateNewProcedureApprovePendingPage(procedureTableData, newRejectReason)}

          {/* @ts-ignore */}
          {this.isApproveCompletePage &&
            this.handleCreateNewProcedureApproveCompletePage(procedureTableData, newRejectReason)}

          {/* @ts-ignore */}
          {this.isSubmitCompletePage &&
            this.handleCreateNewProcedureSubmitCompletePage(procedureTableData)}
        </>
      </NormalSpin>
    );
  }
}
